<div
  class="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] items-stretch gap-4 lg:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]"
>
  <app-dashboard-item [color]="'#916be0'">
    <ng-icon icon name="lucideTrophy"></ng-icon>
    <span>{{ progress() | percent }}</span>
    <span title>{{ "dashboard.dashboard.progress" | translate }}</span>
  </app-dashboard-item>

  <app-dashboard-item
    [color]="'#3587d2'"
    [canClick]="true"
    (click)="navigateToCourses()"
  >
    <ng-icon icon name="lucideBook"></ng-icon>
    <span>{{ openCourses() }}</span>
    <span title>{{ "dashboard.dashboard.active-courses" | translate }}</span>
  </app-dashboard-item>

  <app-dashboard-item
    [color]="'#3aa56b'"
    [canClick]="true"
    (click)="navigateToCourses()"
  >
    <ng-icon icon name="lucideCheck"></ng-icon>
    <span>{{ finishedCourses() }}</span>
    <span title>{{ "dashboard.dashboard.finished-courses" | translate }}</span>
  </app-dashboard-item>

  <app-dashboard-item
    [color]="'#df7023'"
    [canClick]="true"
    (click)="navigateToInstructions()"
  >
    <ng-icon icon name="lucidePointer"></ng-icon>
    <span>{{ openInstructions() }}</span>
    <span title>{{ "dashboard.dashboard.open-instructions" | translate }}</span>
  </app-dashboard-item>

  <app-dashboard-item
    [color]="'#b5e06b'"
    [canClick]="true"
    (click)="navigateToInstructions()"
  >
    <ng-icon icon name="lucideCheck"></ng-icon>
    <span>{{ finishedInstructions() }}</span>
    <span title>{{
      "dashboard.dashboard.finished-instructions" | translate
    }}</span>
  </app-dashboard-item>

  <app-dashboard-item
    [color]="'#7c78ff'"
    [canClick]="true"
    (click)="navigateToInformation()"
  >
    <ng-icon icon name="lucideInfo"></ng-icon>
    <span>{{ information() }}</span>
    <span title>{{ "dashboard.dashboard.information" | translate }}</span>
  </app-dashboard-item>
</div>

@if (instructions().openInstructions.length > 0) {
  <h3 class="mt-8 mb-8 text-xl font-bold text-white">
    {{ "instruction.my-instructions.title" | translate }}
  </h3>

  <div class="flex flex-col gap-4">
    @for (instruction of instructions().openInstructions; track $index) {
      <app-instruction-item
        [instruction]="instruction.instruction"
        [instructionConfirmation]="instruction.confirmation"
        [progress]="instruction.progress"
        (open)="navigateTo($event.instruction, $event.confirmation)"
        [showProgress]="instruction.instruction.type != 'Information'"
      ></app-instruction-item>
    }
  </div>
}
